// Shared dictionary sort-order input parser (#1751: extracted from
// `road-options/RoadOptionForm` so the packaging form does not import the road
// feature; neutral, not a road-options bucket).
//
// WHY (#1152 Codex F-002): the shared schema requires a non-negative
//   integer; `Number.parseInt('1.9')` returns `1` and `Number.parseInt('10abc')`
//   returns `10`, both silently. `Number(s)` rejects partial parses,
//   and `Number.isInteger` rejects decimals. Returns `null` for any
//   input that would fail `Create*InputSchema` / `Patch*InputSchema`.
export function parseSortOrderInput(raw: string): number | null {
  const trimmed = raw.trim();
  if (trimmed.length === 0) return null;
  const n = Number(trimmed);
  if (!Number.isInteger(n) || n < 0) return null;
  return n;
}
